    var topics= {};
    
    const subscribe = (topic, callback) => {
      // Create topic array if it doesn't exist
      if (!topics[topic]) {
        topics[topic] = [];
      }
      
      // Add callback to the topic array
      topics[topic].push(callback);
    };
    
    const publish = (topic, data) => {
      // If topic doesn't exist or has no subscribers, return early
      if (!topics[topic] || topics[topic].length === 0) {
        return;
      }
      
      // Iterate through subscribers and invoke callbacks with data
      topics[topic].forEach(callback => callback(data));
    }

    const reset = ()=>{
      topics = {};
    }
export {topics,subscribe,publish,reset}    